import validate from 'validate-npm-package-name';
import type { TypeNames, GVariantOf } from 'variant';
import { variant, onTerms, payload, nil } from 'variant';

const Result = variant(
  onTerms(({ T }) => ({
    Error: payload(T),
    Ok: nil,
  }))
);

type Result<T, TType extends TypeNames<typeof Result> = undefined> = GVariantOf<
  typeof Result,
  TType,
  { T: T }
>;

export async function validatePackageName(name: string) {
  const result = validate(name);

  if (!result.validForNewPackages) {
    const errors = [...(result.errors ?? []), ...(result.warnings ?? [])];
    return Result.Error(errors);
  }

  return Result.Ok();
}
